// removed by extract-text-webpack-plugin
module.exports = {"header":"src-components-modules-DevHeader-style----general-module---header---2l7Nx position-fixed transitionDuration-m width-100 zi-overlay bg-licorice","default":"src-components-modules-DevHeader-style----general-module---default---6ddDW padding-s","hasScrolled":"src-components-modules-DevHeader-style----general-module---hasScrolled---Ocs5u padding-xs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/DevHeader/style/general.module.css
// module id = 1450
// module chunks = 168707334958949